import { useMemo } from 'react';
import { useAuthUser } from '../../../api';
import type { MonitorSpec } from '../types';
import { AddMonitorStore } from './store';
import { AddMonitorStoreContext } from './useAddMonitorStoreContext';

export interface AddMonitorStoreProviderProps {
	children: React.ReactNode;
	initialMonitorSpec: MonitorSpec;
	initialIntegration?: string;
	initialTable?: string;
	upstreamOf?: string;
}

export function AddMonitorStoreProvider({
	children,
	initialMonitorSpec,
	initialIntegration,
	initialTable,
	upstreamOf,
}: AddMonitorStoreProviderProps) {
	const { user } = useAuthUser();

	const store = useMemo(
		() =>
			new AddMonitorStore(
				initialMonitorSpec,
				user.id,
				initialTable,
				initialIntegration,
				upstreamOf
			),
		[initialMonitorSpec, user.id, initialIntegration, initialTable, upstreamOf]
	);
	return (
		<AddMonitorStoreContext.Provider value={store}>
			{children}
		</AddMonitorStoreContext.Provider>
	);
}
